import { useDispatch } from "react-redux";

import { LoginResponseBodyUserType } from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { clearDashboardFilters } from "../../store/slices/dashboardFilters";
import { clearSitewideDashboardFilters } from "../../store/slices/sitewideDashboardFilters";
import { IgStorage } from "../../utils/igStorage";
import { message } from "../../utils/message";
import { organizationsKeys, userKeys } from "../queryKeys";

import { switchOrganization } from "./switch-organization";

export const useSwitchWidgetOrganization = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation<LoginResponseBodyUserType, Error, any, any>({
    mutationKey: [{ scope: "user" }],
    mutationFn: async (body: { token: string; orgId: string }) =>
      switchOrganization(body.token, body.orgId),
    onSuccess: (data) => {
      // eslint-disable-next-line react-compiler/react-compiler
      IgStorage.authToken = data.token;
      // This should hopefully return the correct org since we just switched
      const org = data.organization;
      message({
        type: "LOGGED_IN",
        payload: {
          id: org?.id,
          name: org?.name,
          shopId: org?.shopId,
          token: data.token,
        },
      });
      dispatch(clearDashboardFilters());
      dispatch(clearSitewideDashboardFilters());
      queryClient.clear();
      queryClient.setQueryData(userKeys.all, data);
      queryClient.setQueryData(organizationsKeys.one, {
        org: data.organization,
      });
      window.close();
    },
  });
};
